// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__eo08H","hour":"Loader_hour__zUApe","min":"Loader_min__dObqL","load9243":"Loader_load9243__zUntP","circel":"Loader_circel__brmnk"};